import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 11.5,
					height: 6,
					rx: 1,
					fill: "#36863A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.18326 9.22727L3.84323 10.3427H3.8688L4.53198 9.22727H5.3134L4.31465 10.8636L5.33578 12.5H4.53997L3.8688 11.383H3.84323L3.17207 12.5H2.37946L3.40378 10.8636L2.39863 9.22727H3.18326Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.84126 12.5V9.22727H6.5332V11.9295H7.93625V12.5H5.84126Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.2599 10.1685C10.2471 10.0396 10.1922 9.93945 10.0953 9.86807C9.99833 9.79669 9.86676 9.76101 9.70057 9.76101C9.58764 9.76101 9.49229 9.77699 9.41452 9.80895C9.33675 9.83984 9.2771 9.88299 9.23555 9.93839C9.19506 9.99378 9.17482 10.0566 9.17482 10.127C9.17269 10.1855 9.18494 10.2367 9.21158 10.2804C9.23928 10.324 9.2771 10.3619 9.32504 10.3938C9.37298 10.4247 9.42837 10.4519 9.49123 10.4753C9.55408 10.4977 9.6212 10.5169 9.69258 10.5328L9.98661 10.6032C10.1294 10.6351 10.2604 10.6777 10.3797 10.731C10.499 10.7843 10.6024 10.8498 10.6897 10.9276C10.7771 11.0053 10.8447 11.0969 10.8927 11.2024C10.9417 11.3079 10.9667 11.4288 10.9678 11.5652C10.9667 11.7654 10.9156 11.9391 10.8144 12.0861C10.7142 12.2321 10.5694 12.3455 10.3797 12.4265C10.1912 12.5064 9.96371 12.5463 9.69737 12.5463C9.43317 12.5463 9.20305 12.5059 9.00703 12.4249C8.81207 12.3439 8.65973 12.2241 8.55 12.0653C8.44134 11.9055 8.38434 11.7079 8.37901 11.4725H9.04858C9.05604 11.5822 9.08747 11.6738 9.14286 11.7473C9.19933 11.8198 9.27443 11.8746 9.36818 11.9119C9.463 11.9482 9.57006 11.9663 9.68938 11.9663C9.80657 11.9663 9.90831 11.9492 9.9946 11.9151C10.082 11.881 10.1496 11.8336 10.1976 11.7729C10.2455 11.7122 10.2695 11.6424 10.2695 11.5636C10.2695 11.4901 10.2476 11.4283 10.2039 11.3782C10.1613 11.3281 10.0985 11.2855 10.0154 11.2504C9.93335 11.2152 9.83267 11.1832 9.71335 11.1545L9.357 11.065C9.08107 10.9979 8.86321 10.8929 8.70341 10.7502C8.54361 10.6074 8.46424 10.4151 8.46531 10.1733C8.46424 9.97514 8.51697 9.80202 8.62351 9.65394C8.73111 9.50586 8.87866 9.39027 9.06616 9.30717C9.25366 9.22407 9.46673 9.18253 9.70536 9.18253C9.94826 9.18253 10.1603 9.22407 10.3414 9.30717C10.5235 9.39027 10.6652 9.50586 10.7664 9.65394C10.8677 9.80202 10.9199 9.97354 10.923 10.1685H10.2599Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 16,
					height: 8,
					rx: 1.5,
					fill: "#36863A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.24434 14.1363L5.12431 15.6236H5.1584L6.04264 14.1363H7.08454L5.75286 16.3182L7.11437 18.5H6.05329L5.1584 17.0106H5.12431L4.22943 18.5H3.17261L4.53837 16.3182L3.19818 14.1363H4.24434Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.78835 18.5V14.1363H8.71093V17.7393H10.5817V18.5H7.78835Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.6798 15.3913C13.6628 15.2194 13.5896 15.0859 13.4604 14.9908C13.3311 14.8956 13.1557 14.848 12.9341 14.848C12.7835 14.848 12.6564 14.8693 12.5527 14.9119C12.449 14.9531 12.3695 15.0106 12.3141 15.0845C12.2601 15.1584 12.2331 15.2422 12.2331 15.3359C12.2303 15.414 12.2466 15.4822 12.2821 15.5405C12.319 15.5987 12.3695 15.6491 12.4334 15.6917C12.4973 15.7329 12.5712 15.7692 12.655 15.8004C12.7388 15.8302 12.8283 15.8558 12.9234 15.8771L13.3155 15.9709C13.5058 16.0135 13.6805 16.0703 13.8396 16.1413C13.9987 16.2123 14.1365 16.2997 14.253 16.4034C14.3695 16.5071 14.4597 16.6292 14.5236 16.7699C14.5889 16.9105 14.6223 17.0717 14.6237 17.2535C14.6223 17.5206 14.5541 17.7521 14.4192 17.9481C14.2857 18.1427 14.0925 18.294 13.8396 18.402C13.5882 18.5085 13.2849 18.5618 12.9298 18.5618C12.5776 18.5618 12.2707 18.5078 12.0094 18.3998C11.7494 18.2919 11.5463 18.1321 11.4 17.9204C11.2551 17.7074 11.1791 17.4439 11.172 17.13H12.0648C12.0747 17.2763 12.1166 17.3984 12.1905 17.4964C12.2658 17.593 12.3659 17.6662 12.4909 17.7159C12.6173 17.7642 12.7601 17.7883 12.9192 17.7883C13.0754 17.7883 13.2111 17.7656 13.3261 17.7202C13.4426 17.6747 13.5328 17.6115 13.5967 17.5305C13.6607 17.4496 13.6926 17.3565 13.6926 17.2514C13.6926 17.1534 13.6635 17.071 13.6053 17.0042C13.5484 16.9375 13.4646 16.8807 13.3538 16.8338C13.2445 16.7869 13.1102 16.7443 12.9511 16.706L12.476 16.5866C12.1081 16.4971 11.8176 16.3572 11.6045 16.1669C11.3915 15.9765 11.2857 15.7202 11.2871 15.3977C11.2857 15.1335 11.356 14.9027 11.498 14.7052C11.6415 14.5078 11.8382 14.3537 12.0882 14.2429C12.3382 14.1321 12.6223 14.0767 12.9405 14.0767C13.2643 14.0767 13.547 14.1321 13.7885 14.2429C14.0314 14.3537 14.2203 14.5078 14.3553 14.7052C14.4902 14.9027 14.5598 15.1314 14.5641 15.3913H13.6798Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 24,
					height: 13,
					rx: 2,
					fill: "#36863A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.86645 24.4545L9.18641 26.6854H9.23754L10.5639 24.4545H12.1267L10.1292 27.7273L12.1715 31H10.5799L9.23754 28.766H9.18641L7.84408 31H6.25885L8.3075 27.7273L6.2972 24.4545H7.86645Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.1825 31V24.4545H14.5663V29.859H17.3724V31H13.1825Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.0197 26.337C21.9941 26.0792 21.8844 25.8789 21.6905 25.7361C21.4966 25.5934 21.2335 25.522 20.9011 25.522C20.6752 25.522 20.4845 25.554 20.329 25.6179C20.1734 25.6797 20.0541 25.766 19.971 25.8768C19.8901 25.9876 19.8496 26.1133 19.8496 26.2539C19.8453 26.3711 19.8698 26.4734 19.9231 26.5607C19.9785 26.6481 20.0541 26.7237 20.15 26.7876C20.2459 26.8494 20.3567 26.9038 20.4824 26.9506C20.6081 26.9954 20.7423 27.0337 20.8851 27.0657L21.4732 27.2063C21.7587 27.2702 22.0208 27.3555 22.2594 27.462C22.498 27.5685 22.7047 27.6996 22.8794 27.8551C23.0541 28.0106 23.1894 28.1939 23.2853 28.4048C23.3833 28.6158 23.4334 28.8576 23.4355 29.1303C23.4334 29.5309 23.3311 29.8782 23.1287 30.1722C22.9284 30.4641 22.6386 30.691 22.2594 30.853C21.8823 31.0128 21.4274 31.0927 20.8947 31.0927C20.3663 31.0927 19.906 31.0117 19.514 30.8498C19.1241 30.6878 18.8194 30.4481 18.5999 30.1307C18.3826 29.8111 18.2686 29.4158 18.258 28.945H19.5971C19.612 29.1644 19.6749 29.3477 19.7857 29.4947C19.8986 29.6396 20.0488 29.7493 20.2363 29.8239C20.4259 29.8963 20.6401 29.9325 20.8787 29.9325C21.1131 29.9325 21.3166 29.8984 21.4891 29.8303C21.6639 29.7621 21.7992 29.6673 21.895 29.5458C21.9909 29.4244 22.0389 29.2848 22.0389 29.1271C22.0389 28.9801 21.9952 28.8565 21.9078 28.7564C21.8226 28.6562 21.6969 28.571 21.5307 28.5007C21.3666 28.4304 21.1653 28.3665 20.9266 28.3089L20.2139 28.13C19.6621 27.9957 19.2264 27.7859 18.9068 27.5003C18.5872 27.2148 18.4284 26.8303 18.4306 26.3466C18.4284 25.9503 18.5339 25.604 18.747 25.3079C18.9622 25.0117 19.2573 24.7805 19.6323 24.6143C20.0073 24.4481 20.4334 24.3651 20.9107 24.3651C21.3965 24.3651 21.8205 24.4481 22.1827 24.6143C22.547 24.7805 22.8304 25.0117 23.0328 25.3079C23.2352 25.604 23.3396 25.9471 23.346 26.337H22.0197Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FileXlsIcon };
